export default (origin, error) => {
  return {
    origin,
    error,
  };
};
